import TicketType from './TicketType'

const ticketReducer = (state, action) => {
  switch (action.type) {
    case TicketType.GET_TICKETS:
      return {
        ...state,
        tickets: action.payload,
        loading: false,
      }
    case TicketType.GET_TICKET:
      return {
        ...state,
        ticket: action.payload,
        loading: false,
      }
    case TicketType.CREATE_TICKET:
      return {
        ...state,
        ticket: action.payload,
        loading: false,
      }
    case TicketType.SEND_TICKET:
      return {
        ...state,
        ticket: action.payload,
        loading: false,
      }
    case TicketType.UPLOAD_FILE:
      return {
        ...state,
        file: action.payload,
        loading: false,
        uploading: false,
      }
    case TicketType.UPDATE_TICKET_LEVEL:
      return {
        ...state,
        ticket: action.payload,
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    case 'SET_UPLOADING':
      return {
        ...state,
        uploading: true,
      }
    default:
      return state
  }
}

export default ticketReducer
